import { jsx as _jsx } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { isPdfRenderedExtension } from "@air/utils-clips";
import { memo } from "react";
export const BoardCollectionGalleryAssetThumbnailMeta = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    return !!clip.ext && (clip.type === ClipType.video || clip.type === ClipType.animated || isPdfRenderedExtension(clip.ext)) ? /*#__PURE__*/ _jsx("div", {
        className: "absolute bottom-2 right-2 z-10",
        children: /*#__PURE__*/ _jsx("span", {
            className: "block rounded-sm bg-pigeon-700 px-1 text-10 font-medium text-white",
            style: {
                letterSpacing: isPdfRenderedExtension(clip.ext) ? 1.44 : 0.32,
                fontWeight: isPdfRenderedExtension(clip.ext) ? "semibold" : "medium"
            },
            children: clip.ext.toUpperCase()
        })
    }) : null;
});
BoardCollectionGalleryAssetThumbnailMeta.displayName = "BoardCollectionGalleryAssetThumbnailMeta";
